var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{attrs:{"config":_vm.modal},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.translations.device_models))])]},proxy:true}])},[_c('Table',{attrs:{"table":_vm.table}}),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }